import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/sales")({
  component: SalesLayout,
});

function SalesLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "sales", actions: ["read"] }]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
